import type { FeatureFlag } from '@nx/state';
import { isFeatureFlag } from '@nx/state';

const SearchParam = {
  /**
   * Used to identify the client application when authenticating against the Relate API
   *
   * Part of Relate configuration for Desktop integration
   */
  appId: 'appId',
  /**
   * Enable given feature flag
   *
   * Can be defined multiple times
   */
  enableFlag: 'enableFlag',
  /**
   * Neo4j Tracking ID, used in Workspace to transfer consent to analytics
   */
  ntid: 'ntid',
  /**
   * Set current Guide Playlist
   */
  playlist: 'playlist',
  /**
   * Access token for Relate API
   *
   * Part of Relate configuration for Desktop integration
   */
  relateApiToken: 'relateApiToken',
  /**
   * Relate API protocol
   *
   * Part of Relate configuration for Desktop integration
   */
  relateUrlProtocol: 'relateUrlProtocol',
  /**
   * Relate API URL
   *
   * Part of Relate configuration for Desktop integration
   */
  relateUrl: 'relateUrl',
};

// TODO: Should be exported from `@nx/state`
interface RelateConfig {
  apiToken: string;
  clientId: string;
  protocol: string;
  url: string;
}

function parseFeatureFlags(searchParams: URLSearchParams): FeatureFlag[] {
  const featureFlags = searchParams.getAll(SearchParam.enableFlag);
  return featureFlags.filter(isFeatureFlag);
}

export function parseRelateConfig(searchParams: URLSearchParams): RelateConfig | null {
  const apiToken = searchParams.get(SearchParam.relateApiToken);
  const clientId = searchParams.get(SearchParam.appId);
  const protocol = searchParams.get(SearchParam.relateUrlProtocol);
  const url = searchParams.get(SearchParam.relateUrl);

  if (apiToken === null || clientId === null || protocol === null || url === null) {
    return null;
  }

  return {
    protocol,
    url,
    apiToken,
    clientId,
  };
}

export function parseSearchParams(url: string): {
  featureFlags: FeatureFlag[];
  playlist: string | null;
  relateConfig: RelateConfig | null;
  userId: string | null;
} {
  const { searchParams } = new URL(window.location.href);

  return {
    featureFlags: parseFeatureFlags(searchParams),
    playlist: searchParams.get(SearchParam.playlist),
    relateConfig: parseRelateConfig(searchParams),
    userId: searchParams.get(SearchParam.ntid),
  };
}
